import { render, staticRenderFns } from "./error-login.vue?vue&type=template&id=547ba645&scoped=true"
import script from "./error-login.vue?vue&type=script&lang=js"
export * from "./error-login.vue?vue&type=script&lang=js"
import style0 from "./error-login.vue?vue&type=style&index=0&id=547ba645&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547ba645",
  null
  
)

export default component.exports